import type { AxiosInstance } from 'axios';

/** Mirrors backend ParticipantType until OpenAPI client regenerates. */
export const ParticipantTypeApi = {
  Individual: 1,
  Entity: 2,
} as const;

/**
 * Typed wrappers around Participant endpoints until OpenAPI client regenerates
 * ParticipantType / EntityDetails on DTOs.
 */
export async function downloadParticipantSample(
  axios: AxiosInstance,
  participantType: number = ParticipantTypeApi.Individual
) {
  return axios.request({
    url: 'api/customer/api/app/participant/download-participant-sample',
    method: 'post',
    params: { participantType },
  });
}
